module.exports = __webpack_public_path__ + "img/pd-img-body2.ebc2439b.png";